import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './TabsFooter.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function TabsFooter({ links, onClassChange }) {
  const location = useLocation();
  const query = useQuery();
  const [state, setState] = useState({
    shipment_stage: '',
    invoicing_status: '',
  });
  const isNew = location.pathname.includes('nouveau');

  function checkSearchQuery() {
    const searchParams = new URLSearchParams(window.location.search);

    // Vérifier si la chaîne de recherche est vide
    if (!searchParams.toString()) {
      return true;
    }

    const allowedKeys = ['page', 'sort'];
    const keys = Array.from(searchParams.keys());
    const onlyAllowedKeys = keys.every(key => allowedKeys.includes(key));

    if (onlyAllowedKeys && keys.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  const getLinkClassName = link => {
    if (
      (location.pathname.includes('/dossiers') ||
        location.pathname.includes('/clients') ||
        location.pathname.includes('/transporteurs')) &&
      (link.url.slice(-9) === '/dossiers' ||
        link.url.slice(-8) === '/clients' ||
        link.url.slice(-14) === '/transporteurs') &&
      !isNew &&
      checkSearchQuery()
    ) {
      return 'current';
    }
    if (link.url.includes('nouveau') && isNew) {
      return 'current';
    }
    if (
      link.url.includes('shipment_stage=' + state.shipment_stage) &&
      state.shipment_stage !== ''
    ) {
      return 'current';
    }
    if (
      link.url.includes('invoicing_status=' + state.invoicing_status) &&
      state.invoicing_status !== ''
    ) {
      return 'current';
    }
    if (link.url.includes('supprimes') && location.pathname.includes('supprimes')) {
      return 'current';
    }
    if (
      (link.url.includes('ca-marge') && location.pathname.includes('ca-marge')) ||
      (link.url.includes('nb-dossiers') && location.pathname.includes('nb-dossiers')) ||
      (link.url.includes('stats/clients') && location.pathname.includes('stats/clients')) ||
      (link.url.includes('stats/litiges') && location.pathname.includes('stats/litiges'))
    ) {
      return 'current';
    }
    return '';
  };

  useEffect(() => {
    const shipment_stage = query.get('shipment_stage');
    const invoicing_status = query.get('invoicing_status');

    setState({
      shipment_stage: shipment_stage ? shipment_stage.replace(' ', '+') : '',
      invoicing_status: invoicing_status ? invoicing_status.replace(' ', '+') : '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <div className="tabs-footer-content">
      <ul>
        {links.map((link, index) => (
          <li key={index} className={link.style}>
            <Link to={link.url} className={getLinkClassName(link)}>
              {link.text}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
